<template
  v-loading="loading"
  element-loading-text="正在下载中"
  element-loading-spinner="el-icon-loading"
  element-loading-background="rgba(0, 0, 0, 0.8)"
>
  <div class="app-container">
    <el-tabs type="border-card">
      <el-tab-pane label="下载对账单" class="order_dowload">
        <div> 每日9:00前完成数据更新，当前数据更新至
          <span>{{ search_time }}</span>
        </div>
        <div> 微信在次日9点启动生成前一天的对账单，建议商户10点后再获取；</div>
        <div>对账单中涉及金额的字段单位为“元”。</div>
        <div>下载账单接口为单日期接口。</div>
      </el-tab-pane>
    </el-tabs>
    <el-form ref="form" :model="form" label-width="80px" style="margin-top: 20px;">
      <el-form-item label="账单类型">
        <el-radio-group v-model="form.type">
          <el-radio label="ALL">所有账单</el-radio>
          <el-radio label="SUCCESS">支付账单</el-radio>
          <el-radio label="REFUND">退款帐单</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="账单时间">
        <el-date-picker
          v-model="form.time"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button class="filter-item" type="success" icon="el-icon-download" @click="OutData">下载对账单</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import api from '@/api/finance' // 和数据交互相关写在api 方便复用
export default {
  name: 'FinanceDivideList',
  components: { },
  // 列绑定格式化器
  filters: {
  },
  mixins: [],
  data() {
    return {
      // api接口方法
      api,
      fromstatus: false,
      checkid: [],
      loading: false,
      search_time: '',
      // 额外过滤条件
      listQuery: {
        search: undefined,
        search_time: []
      },
      form: {
        type: 'ALL',
        time: ''
      }
    }
  },
  created() {
    this.gettime()
  },
  methods: {
    // 获取时间
    gettime() {
      api.getwechatTime().then(response => {
        this.search_time = response.data
        this.form.time = response.data
      })
    },
    // 下载对账单
    OutData() {
      if (this.form.time == null) {
        this.form.time = this.search_time
      }
      this.loading = true
      api.QueryOrderDevide(this.form).then(res => {
        this.loading = false
        window.open(res.data)
        this.$notify({ title: '成功', message: '对账单数据下载成功', type: 'success', duration: 2000 })
      })
    }
  }
}
</script>
<style>
  .order_dowload div{
    padding: 5px 0px;
    color: #666;
    font-size: 12px;
  }
  .order_dowload div span{
      color: red;
  }
  #tab-0{
    color:#333333;
    border: none !important;
    background-color: #F5F7FA;
  }
</style>
